import { createContext, useContext } from 'react';

import { type BasketContextState } from '../types';

const BasketContext = createContext<Nullable<BasketContextState>>(null);

const useBasketContext = () => {
  const context = useContext(BasketContext);
  if (!context) {
    throw new Error('useBasketContext must be used within a BasketProvider');
  }
  return context;
};

export { BasketContext, useBasketContext };
